import styled, { createGlobalStyle } from 'styled-components';

import { Button as BreweryButton } from '@xing-com/button';
import { Button } from '@xing-com/crate-lebenslauf-button';
import { ColorPicker } from '@xing-com/crate-lebenslauf-color-picker';
import { Pagination } from '@xing-com/crate-lebenslauf-components';
import { PAGE_WIDTH, PAGE_HEIGHT } from '@xing-com/crate-lebenslauf-constants';
import { mediaWideNavless, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  space4XL,
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorBackground,
  xdlColorBackgroundTertiary,
  xdlColorText,
} from '@xing-com/tokens';

const PreviewTop = 89;
const PreviewHeaderHeight = 91;
const PreviewFooterHeight = 115;
const AnschreibenBannerHeight = 68;

export const GlobalStyles = createGlobalStyle<{
  $showAnschreibenBanner: boolean;
}>`
  html {
    --previewWidth: min(calc(
      (
          100vh - ${PreviewTop}px - ${PreviewHeaderHeight}px -
            ${PreviewFooterHeight}px - ${({ $showAnschreibenBanner }) =>
              $showAnschreibenBanner ? `${AnschreibenBannerHeight}px` : '0px'}
            ) * ${PAGE_WIDTH} / ${PAGE_HEIGHT}
    ), 50vw);
  }
`;

export const Container = styled.div<{ $hasBanner: boolean }>`
  position: fixed;
  top: ${PreviewTop}px;
  background-color: ${xdlColorBackgroundTertiary};
  bottom: 0;
  right: 0;
  left: 600px;
  overflow: hidden;
  display: none;

  ${({ $hasBanner }) => $hasBanner && `margin-bottom: ${space4XL}}`}

  @media ${mediaWideNavless} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media (min-width: 1920px) {
    left: 32%;
  }
`;

export const ColorPickerStyled = styled(ColorPicker)`
  height: 91px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 115px;
  width: var(--previewWidth);
  margin: 0 auto;
  position: relative;
  padding-top: ${spaceXXL};
`;

export const StyledPreviewButton = styled(Button)<{
  $iconOnlyPreview: boolean;
}>`
  position: fixed;
  right: ${spaceL};
  bottom: ${spaceXL};
  transition: padding-inline 0.2s ease-in;

  ${(props) =>
    props.$iconOnlyPreview &&
    `
    padding-inline: 0;
    transition: padding-inline 0.2s 1s ease-out;
  `}

  * {
    align-items: center;
  }

  @media ${mediaWideNavless} {
    display: none;
  }
`;

export const StyledPreviewButtonText = styled.span<{
  $iconOnlyPreview: boolean;
}>`
  position: relative;
  display: inline-block;
  margin-left: 8px;
  opacity: 1;
  max-width: 80px;
  transition:
    opacity 0.5s 0.7s ease,
    max-width 0.5s 0.2s ease-out,
    margin 0.5s 0.2s ease-out;

  ${(props) =>
    props.$iconOnlyPreview &&
    `
    margin-left: 0;
    opacity: 0;
    max-width: 0;
    transition: opacity 0.5s ease, max-width 0.5s 0.5s ease-in, margin 0.5s 0.5s ease-in;
  `}
`;

export const StyledPagination = styled(Pagination)`
  box-shadow: 0px 2px 5px 1px rgba(33, 42, 54, 0.15);
  border-radius: 20px;
  background-color: ${xdlColorBackground};
  position: absolute;
  top: -22px;
  color: ${xdlColorText};
  left: 50%;
  transform: translateX(-50%);

  & button,
  button:disabled {
    color: ${xdlColorText};
  }
`;

export const StyledLebenslaufButton = styled(BreweryButton)`
  position: fixed;
  right: 30px;
  top: 50%;
  transform: rotate(-90deg) translateX(50%);
  transform-origin: right bottom;

  @media (max-width: 1510px) and (min-height: 1250px) {
    display: none;
  }

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const StyledZoomedPreviewWrapper = styled.div<{ $zoom: number }>`
  width: 100%;
  overflow-y: auto;
  /* This fixes a bug with the chrome scoll bar not appearing when zooming in (only worked when resizing) */
  padding-top: ${({ $zoom }) => ($zoom > 1 ? '1px' : 0)};

  & > * {
    transform: scale(${({ $zoom }) => $zoom});
  }
`;
